import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import Loader from '../loader';

@withRouter
@inject('settingsStore')
@observer
export default class Basket extends React.Component {
  static propTypes = {
    settingsStore: PropTypes.shape({
      setGoBackFunction: PropTypes.func.isRequired,
      setGoBackCapability: PropTypes.func.isRequired,
    }).isRequired,
    history: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  };

  componentWillMount() {
    const {
      settingsStore: { setGoBackFunction, setGoBackCapability, setRouter },
      history,
    } = this.props;

    setGoBackFunction(history.goBack);
    setGoBackCapability(history.canGo(-1));
    setRouter(history);

    history.listen(() => {
      setGoBackCapability(history.canGo(-1));
    });
  }

  render() {
    const { children, settingsStore } = this.props;
    if (settingsStore.isLoading) {
      return <Loader />;
    }
    return (
      <div>
        {React.Children.map(children, child =>
          React.cloneElement(child, ...this.props)
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/basket/basket.js